import React, { useState, useEffect, useCallback, useRef } from "react";
import IconButton from '@mui/material/IconButton';
import Fullscreen from '@mui/icons-material/Fullscreen';
import Button from '@mui/material/Button';

interface IProps {
    sourceUrl: string;
    resize?: boolean;
    title: string;
}

const VideoIframe: React.FC<IProps> = (props) => {
  const { sourceUrl, title, id, callbackSave } = props;

  const iframeRef = useRef<HTMLIFrameElement>(null);
  const defaultHeight = 495;
  const [videoHeight, setVideoHeight] = useState<number>(
    iframeRef.current ? iframeRef.current.offsetWidth * 0.5625 : defaultHeight
  );

  const fullscreen = () => {
    // check if fullscreen mode is available
    if (document.fullscreenEnabled || 
      document.webkitFullscreenEnabled || 
      document.mozFullScreenEnabled ||
      document.msFullscreenEnabled) {
      
      // which element will be fullscreen
      const iframe = iframeRef.current;
      // Do fullscreen
      if (iframeRef.requestFullscreen) {
        iframe.requestFullscreen();
      } else if (iframe.webkitRequestFullscreen) {
        iframe.webkitRequestFullscreen();
      } else if (iframe.mozRequestFullScreen) {
        iframe.mozRequestFullScreen();
      } else if (iframe.msRequestFullscreen) {
        iframe.msRequestFullscreen();
      }
    }
    else {
      alert('Your browser is not supported');
    }
  }

  const onresize = (dom_elem, callback) => {
    const resizeObserver = new ResizeObserver(() => callback() );
    resizeObserver.observe(dom_elem);
  };
  const handleChangeVideoWidth = useCallback(() => {
    const ratio =
      window.innerWidth > 990
        ? 1.0
        : window.innerWidth > 522
        ? 1.2
        : window.innerWidth > 400
        ? 1.45
        : 1.85;
    const height = iframeRef.current
      ? iframeRef.current.offsetWidth * 0.5625
      : defaultHeight;
    return setVideoHeight(Math.floor(height * ratio) - 50);
  }, []);

  const handleChangeVideoWidth2 = useCallback(() => {
    const ratio =
      window.innerWidth > 990
        ? 1.0
        : window.innerWidth > 522
        ? 1.2
        : window.innerWidth > 400
        ? 1.45
        : 1.85;
    const height = iframeRef.current
      ? iframeRef.current.offsetWidth * 0.5625
      : defaultHeight;
    return setVideoHeight(Math.floor(height * ratio) - 50);
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleChangeVideoWidth);
    const ratio =
      window.innerWidth > 990
        ? 1.0
        : window.innerWidth > 522
        ? 1.2
        : window.innerWidth > 400
        ? 1.45
        : 1.85;
    const height = iframeRef.current
      ? iframeRef.current.offsetWidth * 0.5625
      : defaultHeight;
    setVideoHeight(Math.floor(height * ratio) - 50);
    return function cleanup() {
      window.removeEventListener("resize", handleChangeVideoWidth);
    };
  }, [videoHeight, handleChangeVideoWidth]);

  const execCallbackSave = (event) => {
    console.log("Evaluación evento", event)
    callbackSave();
    window.removeEventListener("message",execCallbackSave)
  }

  useEffect(()=>{
    const bb = document.getElementById(id)
    window.addEventListener("message", execCallbackSave)
    onresize(bb, function () {
        handleChangeVideoWidth2()
      })
    return () => {
      window.removeEventListener("message",execCallbackSave)
    }
  }, [])

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div style={{ width: "95%", margin: "auto" }}>
      <Button variant="outlined" onClick={fullscreen}  sx={{ marginLeft: "auto", float: "right" }} startIcon={<Fullscreen />}>
        Full Screen
      </Button>
      </div>
      <iframe
        ref={iframeRef}
        title={title}
        width="95%"
        height={`${videoHeight}px`}
        src={sourceUrl}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
};

export default VideoIframe;